<template>
	<div class="celloger_stack">
		<PageBanner></PageBanner>
		<div id="title" class="stack_title">
			<span class="stack_eng_title">Celloger Stack</span> 全自动细胞工厂成像仪
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div class="stack_container">
			<img src="../assets/img/index/黄色背景图3.jpg" class="y_img3" />
			<p class="p1">全自动细胞工厂成像仪</p>
			<p class="p2">Celloger Stack</p>
			<p class="p3">Celloger Stack是一款自动化多层细胞培养监测系统，可以对培养箱<br>
				中的细胞进行实时成像。该系统能够监测在多层腔室中生长的细胞<br>
				并识别最佳收获时间。全自动的相机可以各个方向移动，只需点击<br>
				一下就可以拍摄行进范围里多个点位的图像并制作成延时视频。</p>
			<img src="../assets/img/production/Stack_2.png" class="stack_img" />
		</div>
		<p class="exp3">Celloger Stack是一款自动化多层细胞培养监测系统，可以对培养箱
			中的细胞进行实时成像。该系统能够监测在多层腔室中生长的细胞
			并识别最佳收获时间。全自动的相机可以各个方向移动，只需点击
			一下就可以拍摄行进范围里多个点位的图像并制作成延时视频。</p>
		<img src="../assets/img/production/产品中心 条幅2.jpg" style="width: 100%;margin-top: 10vh;" />
		<div id="title" style="display: flex; align-items: center;margin-top: 7vh;">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p style="font-size: 30px; font-weight: 500;margin-left: 10px;">主要特点</p>
		</div>
		<p id="title" style="font-size: 25px;font-weight: bold;margin-top: 3vh;">培养箱内实时监测</p>
		<ul id="title" class="subtext" style="line-height: 40px;">
			<li>Celloger Stack优化的细胞检测和成像技术可以实现在标CO2<br class="br">
				培养箱中监测多达10层的细胞培养工厂。（从最底层获取图像）</li>
			<li style="margin-top: 20px;">通过Celloger Stack上放置培养耗材并简单连接到电脑，用户<br class="br">
				无需将细胞从培养箱中取出即可实时观察细胞生长状态。</li>
		</ul>
		<div class="img_container23">
			<img src="../assets/img/production/23.png" class="img_23" />
		</div>
		<p id="title" class="maintext text_6">获得收获细胞的最佳时间</p>
		<ul id="title" class="subtext">
			<li>系统能够根据用户设置的时间表自动拍摄所定位点的图像。</li>
			<li style="margin-top: 20px;">用户可以查看细胞图像选择收获细胞的最佳时间，或设置达到某一融合度自动提醒功能。（开发中）</li>
		</ul>
		<div class="img_container24">
			<img src="../assets/img/production/24.png" class="img_24" />
		</div>
		<p id="title" class="maintext" style="margin-top: 10vh;">多位点拍摄图像</p>
		<ul id="title" class="subtext" style="line-height: 40px;">
			<li>Celloger Stack有一个全自动相机可以分别在X/Y轴移动11 x24cm，<br class="br">
				根据用户设置的时间表在移动范围内进行多位点成像。</li>
			<li style="margin-top: 20px;">用户可以根据研究方案设置各种成像时间表，通过简单地调整即可<br class="br">
				轻松修改时间。</li>
		</ul>
		<div class="img_container25">
			<img src="../assets/img/production/25.png" class="img_25" />
		</div>
		<p id="title" class="maintext text_6">可更换的耗材支架适配不同种耗材</p>
		<ul id="title" class="subtext">
			<li>Celloger Stack可更换的耗材支架适配多种耗材，可以根据实验需求进行调整。</li>
			<li style="margin-top: 20px;">标配一个CellStack的支架，其他不同形状的耗材需根据需求定制。</li>
		</ul>
		<div class="img_container26">
			<img src="../assets/img/production/26.png" class="img_26" />
		</div>
		<p id="title" class="maintext">用户友好的功能</p>
		<div class="img_container27">
			<img src="../assets/img/production/延时视频.jpg" class="img_27" />
		</div>
		<div class="img_container27_1" style="margin-top: 10px;">
			<img src="../assets/img/production/分析工具.jpg" class="img_27_1" />
		</div>
		<div id="title" style="display: flex; align-items: center;margin-top: 10vh;">
			<img src="../assets/img/production/图标1.png" style="width: 33px;height: auto;" />
			<p style="font-size: 25px;font-weight: bold;margin-left: 10px;">更多设备信息</p>
		</div>
		<p id="title" class="subtext" style="margin-bottom: 10vh;text-indent: 2em;">想了解更多产品信息请关注下方官网微信公众号、视频号。</p>
	</div>
</template>

<script>
	import PageBanner from '../components/public/PageBanner.vue'
	import SectionDivider from '../components/public/SectionDivider.vue'
	import scrollReveal from '../mixins/scrollReveal'
	export default {
		name: 'CellogerStack',
		components: {
			PageBanner,
			SectionDivider
		},
		mixins: [scrollReveal],
		revealSelectors: ".stack_container, .img_container23, .img_container24, .img_container25, .img_container26, .img_container27, .img_container27_1"
	}
</script>

<style scoped>
	#title {
		margin-left: calc(50% - 600px);
	}

	.maintext {
		font-size: 30px;
		font-weight: 700;
		margin-top: 10vh;
	}

	.subtext {
		font-size: 18px;
	}

	.stack_container {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.y_img3 {
		margin-top: 20px;
		height: 450px;
		width: 1200px;
	}

	.stack_img {
		position: absolute;
		width: auto;
		height: 330px;
		margin-left: 620px;
		margin-top: 100px;
	}

	.stack_container p {
		position: absolute;
	}

	.stack_container .p1 {
		margin-right: 675px;
		margin-bottom: 200px;
		font-size: 28px;
	}

	.stack_container .p2 {
		margin-right: 600px;
		margin-bottom: 120px;
		font-size: 50px;
		font-family: Rany Bold;
		font-weight: 700;
	}

	.stack_container .p3 {
		margin-right: 400px;
		margin-top: 200px;
		font-size: 18px;
		line-height: 2;
	}

	.img_23 {
		position: absolute;
		margin-left: 50vw;
		margin-bottom: 20vh;
	}

	.img_24 {
		width: 980px;
		height: 390px;
		margin-top: 5vh;
	}

	.img_25 {
		width: 460px;
		height: 580px;
		position: absolute;
		margin-left: 50vw;
		margin-bottom: 10vh;
	}

	.img_26 {
		width: 1000px;
		height: 640px;
	}

	.img_27, .img_27_1 {
		width: 1125px;
		height: 363px;
	}

	.img_container23, .img_container24, .img_container25, .img_container26, .img_container27, .img_container27_1 {
		display: flex;
		justify-content: center;
		align-items: center;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.content-center {
		transform: translateY(0);
		opacity: 1;
	}

	.stack_title {
		font-size: 2em;
		margin-top: 6vh;
		letter-spacing: 1px;
	}

	.stack_eng_title {
		font-family: Rany;
		font-weight: 600;
		font-size: 30px;
	}

	.progress {
		width: 200px;
		margin-top: 10px;
		margin-bottom: 5vh;
	}

	.exp3 {
		display: none;
	}

	.icon1 {
		width: 33px;
		height: auto;
	}

	.text_6 {
		margin-top: 25vh;
	}

	@media screen and (max-width: 1150px) {
		#title {
			margin-left: calc(50% - 450px);
		}

		.y_img3 {
			margin-top: 20px;
			height: auto;
			width: 100%;
		}

		.stack_img {
			position: absolute;
			width: auto;
			height: 250px;
			margin-left: 530px;
			margin-top: 50px;
		}

		.stack_container .p1 {
			margin-right: 540px;
			font-size: 1.5rem;
		}

		.stack_container .p2 {
			margin-right: 550px;
			font-size: 2rem;
		}

		.stack_container .p3 {
			margin-right: 300px;
			font-size: 1rem;
			margin-top: 150px;
		}

		.img_23 {
			width: 320px;
			height: auto;
			margin-left: 550px;
		}

		.img_24 {
			width: 880px;
			height: 350px;
		}

		.img_25 {
			width: 380px;
			height: 480px;
			margin-left: 610px;
		}

		.img_26 {
			width: 900px;
			height: 580px;
		}

		.img_27, .img_27_1 {
			width: 950px;
			height: 305px;
		}
	}

	@media screen and (max-width: 800px) {
		#title {
			margin-left: calc(50% - 180px);
		}

		.maintext {
			font-size: 25px;
		}

		.stack_title {
			font-size: 1.1rem;
			margin-top: 5vh;
		}

		.stack_eng_title {
			font-weight: 500;
			font-size: 1.1rem;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.y_img3 {
			margin-top: 20px;
			height: calc(180px + 10vw);
			width: 100%;
		}

		.stack_container .p1, .stack_container .p2 {
			font-size: 1.2rem;
			margin-right: 180px;
			margin-top: 160px;
		}

		.stack_container .p3 {
			display: none;
		}

		.exp3 {
			display: block;
			margin-right: 30px;
			margin-left: 30px;
			font-size: 1rem;
			line-height: 2;
			text-indent: 2em;
		}

		.stack_img {
			position: absolute;
			height: 150px;
			width: auto;
			margin-top: 20px;
			margin-left: 180px;
		}

		.icon1 {
			width: 25px;
			height: auto;
		}

		.img_23 {
			position: relative;
			margin-left: 0;
			margin-bottom: 0;
		}

		.img_24 {
			width: 380px;
			height: auto;
			margin-top: 5vh;
		}

		.img_25 {
			width: 380px;
			height: auto;
			position: relative;
			margin-left: 0;
			margin-bottom: 0;
		}

		.img_26 {
			width: 380px;
			height: auto;
		}

		.img_27, .img_27_1 {
			width: 420px;
			height: auto;
		}

		.subtext {
			margin-right: 20px;
			line-height: 2rem;
		}

		.br {
			display: none;
		}

		.text_6 {
			margin-top: 100px;
		}
	}
</style>